<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Contents</h2>
<p class="firstverse"><a href="#/Text/Introduction">Introduction:</a></p>
<p class="firstverse"><a href="#/Text/UncommonDecency1">1 Convicted Civility</a><br/>
  Can We Be Faithful &amp; Polite Too?</p>
<p class="firstverse"><a href="#/Text/UncommonDecency2">2 What Christian Civility Is Not</a></p>
<p class="firstverse"><span href="#/Text/UncommonDecency3" title="Link target outside of Sample">3 Defending Christian Civility</span></p>
<p class="firstverse"><span href="#/Text/UncommonDecency4" title="Link target outside of Sample">4 Speaking in God's Presence</span><br/>
  The Importance of Civil Speech</p>
<p class="firstverse"><span href="#/Text/UncommonDecency5" title="Link target outside of Sample">5 Open Hearts</span><br/>
  The Importance of Civil Attitudes</p>
<p class="firstverse"><span href="#/Text/UncommonDecency6" title="Link target outside of Sample">6 The Spiritual Underpinnings</span></p>
<p class="firstverse"><span href="#/Text/UncommonDecency7" title="Link target outside of Sample">7 What’s Good About Pluralism?</span></p>
<p class="firstverse"><span href="#/Text/UncommonDecency8" title="Link target outside of Sample">8 How to Be Civil About Sex</span></p>
<p class="firstverse"><span href="#/Text/UncommonDecency9" title="Link target outside of Sample">9 The Challenge of Other Religions</span></p>
<p class="firstverse"><span href="#/Text/UncommonDecency10" title="Link target outside of Sample">10 Christian Leadership in a Pluralistic World</span></p>
<p class="firstverse"><span href="#/Text/UncommonDecency11" title="Link target outside of Sample">11 When There Is No “On the Other Hand”</span><br/>
  The Limits of Civility</p>
<p class="firstverse"><span href="#/Text/UncommonDecency12" title="Link target outside of Sample">12 Is Hell Uncivil?</span></p>
<p class="firstverse"><span href="#/Text/UncommonDecency13" title="Link target outside of Sample">13 Abraham Kuyper, Meet Mother Teresa</span><br/>
  The Problem of Triumphalism</p>
<p class="firstverse"><span href="#/Text/UncommonDecency14" title="Link target outside of Sample">14 Serving a Slow God</span><br/>
  Civility and the End of Time</p>
<p class="firstverse"><span href="#/Text/Afterword" title="Link target outside of Sample">Afterword: A Civil Hug</span></p>
<p class="firstverse"><span href="#/Text/eNotes" title="Link target outside of Sample">Notes</span></p>
<p class="firstverse"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5b73c5ba